import React, { useContext, useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import "../assets/scss/core.scss";
import common from "../config/config.common";
import { AuthContext } from "../context/AuthContext";
import useApiClient, { apiRoutes } from "../hooks/apiClient";
import ImgMarca from "../assets/img/marca-horizontal-cor.png";
import appConfig from "../config/app.config";

const submitSignin = (credentials, request) => {
  const headers = {
    Authorization: `Basic ${window.btoa(`${credentials.codigoUsuario.toUpperCase()}:${credentials.password}`)}`,
    captcha_token: credentials.captchaData.result.secret,
    captcha_value: credentials.captcha,
  };

  const params = {
    scope: "openid",
    response_type: "code id_token",
    client_id: common.clientId,
    redirect_uri: "https://efis.sefaz.rn.gov.br",
    state: Math.random().toString(36).slice(2),
  };

  request(apiRoutes.auth.autenticacao.signInBasic, params, { headers });
};

const Login = () => {
  const authContext = useContext(AuthContext);
  const location = useLocation();

  const { request: requestCaptcha, data: captchaData } = useApiClient(false);

  const { request: requestSignin, data: signinData, errors: signinErros, isLoading } = useApiClient();

  const { request: requestSigninSso, data: signinSsoData, errors: signinSsoErrors } = useApiClient(false);

  const [codigoUsuario, setCodigoUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState(appConfig.env === "prod" ? "" : "N0N35");
  const [showErro, setshowErro] = useState(false);
  const [showErroSSo, setshowErroSSo] = useState(false);
  const [messageErro, setMessageErro] = useState("");
  const [messageErroSSo, setMessageErroSSo] = useState("");
  const [urlErrorHandled, setUrlErrorHandled] = useState(false);
  const [skipSsoRequest, setSkipSsoRequest] = useState(false);

  useEffect(() => {
    localStorage.clear();

    // Check for sso=false and error_description in URL parameters
    const urlParams = new URLSearchParams(location.search);
    const ssoParam = urlParams.get("sso");
    const errorDescription = urlParams.get("error_description") || "Erro de autenticação via SSO";

    if (ssoParam === "false" && errorDescription) {
      setMessageErroSSo(errorDescription);
      setshowErroSSo(true);
      setUrlErrorHandled(true);
      setSkipSsoRequest(true);
    } else {
      // Reset states if URL params are not present
      setUrlErrorHandled(false);
      setSkipSsoRequest(false);
    }

    requestCaptcha(apiRoutes.auth.autenticacao.getCaptcha);
  }, [location, requestCaptcha]);

  useEffect(() => {
    if (signinData) {
      authContext.handleLogin(signinData);
    } else if (signinErros) {
      setMessageErro(signinErros.message);
      setshowErro(true);
    }
  }, [signinData, signinErros, authContext]);

  useEffect(() => {
    if (signinSsoData) {
      authContext.handleLogin(signinSsoData);
    }
  }, [signinSsoData, authContext]);

  useEffect(() => {
    if (signinSsoErrors && !urlErrorHandled) {
      const is403Error =
        signinSsoErrors.message?.toLowerCase().includes("403") ||
        signinSsoErrors.message?.toLowerCase().includes("forbidden") ||
        signinSsoErrors.message?.toLowerCase().includes("acesso negado");

      if (is403Error) {
        setMessageErro(
          "Acesso restrito durante validação do SSO. O serviço está em fase de validação com acesso restrito aos usuários previamente autorizados.",
        );
      } else {
        setMessageErro(signinSsoErrors.message || "Erro ao autenticar via SSO");
      }

      setshowErro(true);
    }
  }, [signinSsoErrors, urlErrorHandled]);

  useEffect(() => {
    if (!skipSsoRequest) {
      requestSigninSso(apiRoutes.auth.autenticacao.signInSso);
    }
  }, [requestSigninSso, skipSsoRequest]);

  return (
    <div className="container">
      {/* Outer Row */}
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              {/* Nested Row within Card Body */}
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block bg-login-image" />
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <img
                        src={ImgMarca}
                        width="50%"
                        className="d-inline-block align-top pb-5 d-lg-none"
                        alt="efis logo"
                      />
                      <h1 className="h4 text-gray-900 mb-4">Bem vindo(a)!</h1>
                    </div>
                    <form className="login">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control form-control-login"
                          onChange={(e) => setCodigoUsuario(e.target.value)}
                          placeholder="Entre com seu usuário"
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control form-control-login"
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Digite sua senha"
                        />
                      </div>
                      <div className="form-group text-center">
                        {captchaData && <img src={captchaData.result.arquivo} alt="Captcha" className="w-100" />}
                        <p className="mt-3">
                          <Button
                            variant="link"
                            onClick={() => {
                              setCaptcha("");
                              requestCaptcha(apiRoutes.auth.autenticacao.getCaptcha);
                            }}
                          >
                            <i className="fas fa-sync-alt" />
                            &nbsp;Recarregar captcha
                          </Button>
                        </p>
                      </div>
                      <div className="form-group text-center">
                        <input
                          type="text"
                          className="form-control form-control-login"
                          value={captcha}
                          onChange={(e) => setCaptcha(e.target.value)}
                          placeholder="Digite o captcha"
                        />
                      </div>
                      {/* <div className="form-group">
                      <div className="custom-control custom-checkbox small">
                        <input type="checkbox" className="custom-control-input" id="customCheck" />
                        <label className="custom-control-label" htmlFor="customCheck">
                          Lembrar-me
                        </label>
                      </div>
                    </div> */}
                      <div className="form-group text-center">
                        {showErro ? (
                          <>
                            <br />
                            <div className="alert alert-danger" role="alert">
                              {messageErro}
                            </div>
                          </>
                        ) : null}
                        {isLoading ? (
                          <span>
                            <Spinner animation="border" role="status" />
                            &nbsp;Acessando...
                          </span>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              submitSignin(
                                {
                                  codigoUsuario,
                                  password,
                                  captcha,
                                  captchaData,
                                },
                                requestSignin,
                              );
                            }}
                            disabled={!codigoUsuario || !password || !captcha || !captchaData}
                            className="btn btn-secondary btn-login btn-block"
                          >
                            Entrar
                          </button>
                        )}
                      </div>
                      <div>
                        {showErroSSo ? (
                          <>
                            <div className="alert alert-danger" role="alert">
                              {messageErroSSo}
                            </div>
                          </>
                        ) : null}
                        <button
                          type="button"
                          className="btn btn-primary btn-login btn-block"
                          onClick={() => {
                            window.location = `${appConfig.hosts.auth}v1/sso/auth/54bcfa1d`;
                          }}
                        >
                          SSO SEFAZ-RN
                        </button>
                      </div>
                    </form>
                    <hr />
                    <div className="text-center">
                      <Button variant="link" className="small">
                        Esqueceu seus dados?
                      </Button>
                    </div>
                    <div className="text-center">
                      <Button variant="link" className="small">
                        Crie sua conta!
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
